<template>
<div :class="[{'col-auto':auto},sizeClass,offsetClass]">
  <slot></slot>
</div>
</template>
<script>
export default {
  name:'column',
  props: {
    offset:{},
    sizes:{},
    auto:Boolean,
  },
  computed:{
    sizeClass () {
      var classes = _.map(this.sizes, (size,bp)=>{
        return 'col-'+bp+'-'+size
      })
      if(classes.length == 0) classes = 'col'
      return [classes]
    },
    offsetClass () {
      var classes = _.map(this.offset, (size,bp)=>{
        return 'offset-'+bp+'-'+size
      })
      if(classes.length == 0) return false
      return [classes]
    }
  }
}
</script>